import { render, staticRenderFns } from "./Etapa9.vue?vue&type=template&id=f4b31ce4&scoped=true"
import script from "./Etapa9.vue?vue&type=script&lang=js"
export * from "./Etapa9.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=f4b31ce4&prod&scoped=true&lang=scss&external"
import style1 from "./Etapa9.vue?vue&type=style&index=1&id=f4b31ce4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b31ce4",
  null
  
)

export default component.exports